// import { Breadcrumb } from "antd";
import React, { useEffect, useState } from "react";
// import breadcrumb from "../../assets/images/breadcrumb.svg";
// import backBtn from "../../assets/images/backBtn.svg";
// import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import dpcPhone from "../../assets/images/dpcPhone.svg";
import dpcGloble from "../../assets/images/dpcGloble.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import downloadPdf from "../../assets/images/downloadPdf.svg";
import { useCommonMessage } from "../../common/CommonMessage";
import { useDispatch, useSelector } from "react-redux";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import NoDataFound from "../NoDataFound/NoDataFound";
import { getItem } from "../../common/localStorage";
import { getProductListHandler } from "../../redux/action/getProductList";
import { ssoDialCareAction, ssoDialCareHandler } from "../../redux/action/ssoDialCare";
import { ssoLyricUrlAction, ssoLyricUrlHandler } from "../../redux/action/ssoLyricUrl";
import Loader from "../Loder/loader";

const Dpcextra = () => {
  const [pdfUrl, setPdfUrl] = useState("");
  const { state } = useLocation();
const getAdminId = getItem("adminId");
  const { t } = useTranslation();
  const messageApi = useCommonMessage();
  const dispatch = useDispatch()

  const ssoDialCareSelector = useSelector((state) => state?.ssoDialCare);
  const ssoLyricUrlSelector = useSelector((state) => state?.ssoLyricUrl);

  const handleDownload = () => {
    const fileUrl = state?.itemData?.detailContent?.fileUrl;
    if (fileUrl) {
      window.open(fileUrl, "_blank");
    } else if(!fileUrl) {
      messageApi.open({
        type: "error",
        content: "Website link is not available",
      });
    }
  };

  const navigateToWebsite = () => {
    let payload = {
      url: state?.itemData?.detailContent?.url,
    }
    dispatch(ssoLyricUrlHandler(payload));
  };

  const goToPhone = () => {
    if (state?.itemData?.detailContent?.phone) {
      const phoneNumber = state?.itemData?.detailContent?.phone;
      return phoneNumber ? `tel:${phoneNumber}` : "#";
    } else {
      messageApi.open({
        type: "error",
        content: "Phone is not available",
      });
    }
  };

  const virtualCareHandler = () => {
    dispatch(ssoDialCareHandler());
  };
console.log("ssoLyricUrlSelector", ssoLyricUrlSelector);
  useEffect(() => {
    if (ssoDialCareSelector?.data?.statusCode === 200) {
      window.open(ssoDialCareSelector?.data?.data?.url,"_blank")
      messageApi.open({
        type: "success",
        content: ssoDialCareSelector?.data?.message,
      });
      dispatch(ssoDialCareAction.ssoDialCareInfoReset());
    } else if (ssoDialCareSelector?.data?.statusCode === 403) {
      messageApi.open({
        type: "error",
        content: ssoDialCareSelector?.data?.message,
      });
      dispatch(ssoDialCareAction.ssoDialCareInfoReset());
    } else if (ssoDialCareSelector?.message) {
      messageApi.open({
        type: "error",
        content: ssoDialCareSelector?.message,
      });
      dispatch(ssoDialCareAction.ssoDialCareInfoReset());
    }
  }, [ssoDialCareSelector]);

  useEffect(() => {
    if (ssoLyricUrlSelector?.data?.statusCode === 200) {
      const url = ssoLyricUrlSelector?.data?.data?.url;
      if (url) {
        window.open(url, "_blank");
        messageApi.open({
          type: "success",
          content: ssoLyricUrlSelector?.data?.message,
        });
      } else {
        messageApi.open({
          type: "error",
          content: "Website link is not available",
        });
      }
      dispatch(ssoLyricUrlAction.ssoLyricUrlInfoReset());
    } else if (ssoLyricUrlSelector?.data?.statusCode === 403) {
      messageApi.open({
        type: "error",
        content: ssoLyricUrlSelector?.data?.message,
      });
      dispatch(ssoLyricUrlAction.ssoLyricUrlInfoReset());
    } else if (ssoLyricUrlSelector?.message) {
      messageApi.open({
        type: "error",
        content: ssoLyricUrlSelector?.message,
      });
      dispatch(ssoLyricUrlAction.ssoLyricUrlInfoReset());
    }
  }, [ssoLyricUrlSelector]);
  
  useEffect(() => {
    const url = state?.itemData?.detailContent?.fileUrl;
    if (url) {
      setPdfUrl(url);
    } else {
      console.error("PDF URL is invalid or missing");
    }
  }, [state]);

   useEffect(() => {
      if (getAdminId) {
        let payload = {
          userId: getAdminId,
          refBrandId: 1,
        };
        dispatch(getProductListHandler(payload));
      }
    }, [getAdminId]);

  return (
    <>
    {(ssoDialCareSelector?.isLoading || ssoLyricUrlSelector?.isLoading) && <Loader loaderTransForm = "loaderTransForm" />}
      <div className="container">
        <div className="pdfViewer">
          <div className="d-flex dpcBtns justify-center gap-20 mb-30">
            {state?.itemData?.detailContent?.phone &&
            state?.itemData?.detailContent?.url ? (
              <>
                <a className="dpcBtn" href={goToPhone()}>
                  <img src={dpcPhone} alt="" />
                  <div>{t("Phone")}</div>
                </a>
                <div className="dpcBtn" onClick={navigateToWebsite}>
                  <img src={dpcGloble} alt="" />
                  <div>{t("Website")}</div>
                </div>
              </>
            ) : state?.itemData?.detailContent?.phone ? (
              <>
              <a className="dpcBtn" href={goToPhone()}>
                <img src={dpcPhone} alt="" />
                <div>{t("Phone")}</div>
              </a>
              </>
            ) : state?.itemData?.detailContent?.virtualCare ? (
              <>
                <div className="dpcBtn" onClick={virtualCareHandler}>
                  <div>{t("Virtual Care")}</div>
                </div>
              </>
            ) : state?.itemData?.detailContent?.url ? (
              <div className="dpcBtn" onClick={navigateToWebsite}>
                <img src={dpcGloble} alt="" />
                <div>{t("Website")}</div>
              </div>
            ) : null}
          </div>
          {/* {state?.itemData?.detailContent?.fileUrl && ( */}
            <div className=" mx-auto position-relative">
              <div className="pdfReview mb-40">
                {pdfUrl ? (
                  <>
                    <Worker
                      workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
                    >
                      <Viewer fileUrl={pdfUrl} />
                    </Worker>
                    <div className="downloadPdf" onClick={handleDownload}>
                      <img src={downloadPdf} alt="" />
                    </div>
                  </>
                ) : (
                  <NoDataFound />
                )}
              </div>
            </div>
          {/* )} */}
        </div>
      </div>
    </>
  );
};

export default Dpcextra;
